import axios from 'axios'

export default async function defaultRequest({ method = 'get', data = {}, url }: { method: string; data?: any; url: string }) {
    return new Promise((resolve, reject) => {
        axios({
            method,
            url,
            data,
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            }
        }).then((res) => {
            resolve(res.data)
        }).catch((error) => {
            reject(error)
        })
    })
}